import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var InputWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  color: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n\n  label {\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.15px;\n    color: ", ";\n  }\n\n  &:has(input:disabled) {\n    label {\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n\n  color: ", ";\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: 0.1px;\n\n  label {\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    letter-spacing: 0.15px;\n    color: ", ";\n  }\n\n  &:has(input:disabled) {\n    label {\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.label.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
});
export var InputContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n\n  color: ", ";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.4px;\n\n  svg {\n    fill: ", ";\n    width: ", ";\n    height: ", ";\n  }\n\n  .icon-left {\n    width: ", ";\n    height: ", ";\n    position: absolute;\n    left: 16px;\n    bottom: 50%;\n    transform: translateY(50%);\n  }\n\n  .icon-right {\n    width: ", ";\n    height: ", ";\n    position: absolute;\n    right: 16px;\n    bottom: 50%;\n    transform: translateY(50%);\n  }\n\n  .error-icon {\n    position: absolute;\n    right: 16px;\n    fill: ", ";\n    bottom: 50%;\n    transform: translateY(50%);\n  }\n\n  &:has(input:disabled) {\n    svg {\n      fill: ", ";\n    }\n  }\n\n  input {\n    height: ", ";\n    width: 100%;\n    padding: ", ";\n    border-radius: ", ";\n    border: 1px solid ", ";\n    background-color: transparent;\n\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    letter-spacing: 0.1px;\n\n    ", "\n    ", "\n\n    ", "\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &:focus-visible {\n      border: 1px solid ", ";\n    }\n\n    &:disabled {\n      cursor: default;\n      color: ", ";\n      border-color: ", ";\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n  }\n"], ["\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n\n  color: ", ";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px; /* 133.333% */\n  letter-spacing: 0.4px;\n\n  svg {\n    fill: ", ";\n    width: ", ";\n    height: ", ";\n  }\n\n  .icon-left {\n    width: ", ";\n    height: ", ";\n    position: absolute;\n    left: 16px;\n    bottom: 50%;\n    transform: translateY(50%);\n  }\n\n  .icon-right {\n    width: ", ";\n    height: ", ";\n    position: absolute;\n    right: 16px;\n    bottom: 50%;\n    transform: translateY(50%);\n  }\n\n  .error-icon {\n    position: absolute;\n    right: 16px;\n    fill: ", ";\n    bottom: 50%;\n    transform: translateY(50%);\n  }\n\n  &:has(input:disabled) {\n    svg {\n      fill: ", ";\n    }\n  }\n\n  input {\n    height: ", ";\n    width: 100%;\n    padding: ", ";\n    border-radius: ", ";\n    border: 1px solid ", ";\n    background-color: transparent;\n\n    color: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px; /* 142.857% */\n    letter-spacing: 0.1px;\n\n    ", "\n    ", "\n\n    ", "\n\n    &::placeholder {\n      color: ", ";\n    }\n\n    &:hover {\n      border-color: ", ";\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &:focus-visible {\n      border: 1px solid ", ";\n    }\n\n    &:disabled {\n      cursor: default;\n      color: ", ";\n      border-color: ", ";\n\n      &::placeholder {\n        color: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return "calc(".concat(theme.components.input.input.fontSize[theme.device], " + 6px)");
}, function (_a) {
    var theme = _a.theme;
    return "calc(".concat(theme.components.input.input.fontSize[theme.device], " + 6px)");
}, function (_a) {
    var theme = _a.theme;
    return "calc(".concat(theme.components.input.input.fontSize[theme.device], " + 6px)");
}, function (_a) {
    var theme = _a.theme;
    return "calc(".concat(theme.components.input.input.fontSize[theme.device], " + 6px)");
}, function (_a) {
    var theme = _a.theme;
    return "calc(".concat(theme.components.input.input.fontSize[theme.device], " + 6px)");
}, function (_a) {
    var theme = _a.theme;
    return "calc(".concat(theme.components.input.input.fontSize[theme.device], " + 6px)");
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.red.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.height[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.padding[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.borderRadius[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.family.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.components.input.input.fontSize[theme.device];
}, function (_a) {
    var $hasIconLeft = _a.$hasIconLeft;
    return $hasIconLeft && "padding-left: 40px;";
}, function (_a) {
    var $hasIconRight = _a.$hasIconRight;
    return $hasIconRight && "padding-right: 40px;";
}, function (_a) {
    var $hasError = _a.$hasError, theme = _a.theme;
    return $hasError &&
        "border-color: ".concat(theme.colors.red.default, ";\n      padding-right: 36px;");
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.default;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.darker;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.neutral.light;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map